import * as yup from "yup";
import Notification from "../../helpers/notifications";

export const isValidSignUpForm = async (form_data) => {
    const {
        name,
        mobile,
        email,
        identification_code,
        license
    } = form_data;

    const shape = {
        name: yup.string().matches(/^([^0-9]*)$/, 'نام و نام خانوادگی معتبر وارد کنید').required('نام و نام خانوادگی الزامیست'),
        mobile: yup.string().matches(/^[0-9]+$/, 'یک تلفن همراه معتبر وارد کنید').length(11, 'یک تلفن همراه معتبر وارد کنید').required('تلفن همراه الزامیست'),
        email: yup.string().email('یک ایمیل معتبر وارد کنید'),
        identification_code: yup.string().matches(/^[0-9]+$/, 'یک کد ملی معتبر وارد کنید').length(10, 'یک کد ملی معتبر وارد کنید').typeError('یک کد ملی معتبر وارد کنید').required('کد ملی الزامیست'),
        // license: yup.array().min(1, 'انتخاب حداقل یک عکس الزامیست').max(10, 'حداکثر عکس قابل انتخاب ۱۰ عدد می باشد').of(yup.string()),
    }

    const schema = yup.object().shape(shape);

    try {
        await schema.validate({
            name,
            mobile,
            email,
            identification_code,
            // license
        });
        return true;
    } catch (e) {
        Notification.danger(e.message)
        return false;
    }
}

export const isValidVerificationCode = async (verification_code) => {
    const shape = {
        verification_code: yup.string().matches(/^[0-9]+$/, 'کد فعالسازی نامعتبر').length(6, 'کد فعالسازی نامعتبر').required('وارد کردن کد فعالسازی الزامیست'),
    }

    const schema = yup.object().shape(shape);

    try {
        await schema.validate({
            verification_code,
        });
        return true;
    } catch (e) {
        Notification.danger(e.message)
        return false;
    }
}
